import React, {Component} from 'react';
import './App.css';
import Home from '../components/Home';

import {Route, Switch, BrowserRouter} from 'react-router-dom';

class App extends Component {

    render() {
        return (

            <BrowserRouter>
                <div className='App'>
                    <Switch>
                        <Route exact path='/' component={Home}/>
                    </Switch>
                </div>
            </BrowserRouter>

        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/app/App.js